import { useEffect, useRef } from 'react'
import { useBlocker } from 'react-router-dom'

export const useUnsavedChangesAlert = (hasUnsavedChanges: boolean) => {
  const blocker = useBlocker(hasUnsavedChanges)
  // Keep a stable ref so the effect below doesn't re-run on every render
  // (useBlocker returns a new object reference on each render).
  const blockerRef = useRef(blocker)
  blockerRef.current = blocker

  useEffect(() => {
    if (blocker.state !== 'blocked') return

    if (window.confirm('Möchtest du wirklich die Seite wechseln? Deine Änderungen gehen dadurch verloren.')) {
      blockerRef.current.proceed?.()
    } else {
      blockerRef.current.reset?.()
    }
  // Only react to actual state changes, not to the new object reference.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocker.state])
}
